import type { QueryRef } from '@apollo/client';
import {
  NetworkStatus,
  useQueryRefHandlers,
  useReadQuery,
} from '@apollo/client';
import { startTransition } from 'react';
import { useLoaderData } from 'react-router';

import { useLoadMore } from './usePaginatedQuery';

export const useQueryLoader = <TData>() => {
  const queryRef = useLoaderData() as QueryRef<TData>;
  if (!queryRef) {
    throw new Error(
      'useQueryLoader must be used within a route that has a query loader. Did you forget to export the loader?'
    );
  }
  const { refetch, fetchMore, subscribeToMore } = useQueryRefHandlers(queryRef);
  const { data, error, networkStatus } = useReadQuery(queryRef);
  const loadMore = useLoadMore({ fetchMore, options: null });

  return {
    data,
    error,
    networkStatus,
    refetch,
    loadMore: (...args: Parameters<typeof loadMore>) =>
      startTransition(() => {
        loadMore(...args);
      }),
    subscribeToMore,
    loading: networkStatus === NetworkStatus.loading,
  };
};
